var exports = {
  "KM": "xaee3c4fa--4b0fbe--bg-wrapper",
  "iE": "xaee3c4fa--4b0fbe--wrapper",
  "Ns": "xaee3c4fa--4b0fbe--simple-wrapper",
  "P2": "xaee3c4fa--4b0fbe--_opened",
};

module.exports = exports;
